import { Chip, ChipDelete, Stack } from '@mui/joy';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { Color, Direction, Size, Variant } from 'theme/enums';

export interface IAppliedFilter {
  key: string;
  label: string;
  onRemove: () => void;
}

interface IProps {
  filters: IAppliedFilter[];
  onResetAll: () => void;
}

// The narrowing as removable chips, with Reset All in front.
export const AppliedFilters = ({ filters, onResetAll }: IProps) => {
  const { t } = useTranslation();

  if (!filters.length) {
    return null;
  }

  return (
    <Stack direction={Direction.ROW} sx={{ alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
      <Button
        text={t('buttonLabelResetAll')}
        variant={Variant.PLAIN}
        color={Color.DANGER}
        onClick={onResetAll}
      />
      {filters.map(({ key, label, onRemove }) => (
        <Chip
          key={key}
          size={Size.MD}
          variant={Variant.OUTLINED}
          endDecorator={<ChipDelete onDelete={onRemove} />}
        >
          {label}
        </Chip>
      ))}
    </Stack>
  );
};
